import { Button } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';
import { pandaFaceImage } from '@app/assets';

interface PlusButtonProps {
  onClick: () => void;
}

export function PlusButton({ onClick }: PlusButtonProps) {
  return (
    <Button
      variant="custom"
      className={cn(
        'cursor-pointer flex h-[28px] w-[73px] items-center justify-center gap-1 overflow-hidden rounded-full border-b border-r border-home-card-border bg-home-card-bg shadow-home-plus'
      )}
      onClick={onClick}
    >
      <span
        className={cn(
          'absolute -bottom-[5px] h-2.5 w-[45px] rounded-[50%] blur-lg',
          'bg-home-plus-glow'
        )}
      />
      <span className={cn('relative text-[22px] leading-none', 'text-home-plus-icon')}>+</span>
      <img src={pandaFaceImage} alt="panda" className="relative w-5" />
    </Button>
  );
}
